module.exports = __webpack_public_path__ + "static/media/arrow-right.2b209cc8.svg";